<ng-container *transloco="let t;">
      <div class="detailFirstColumn">
        <label class="col-form-label">{{ field.label }}</label>
      </div>
      <div class="form-group">
        <ng-select [ngModel]="selectedTags"
                   (ngModelChange)="onTagsModelChange($event)"
                   [ngModelOptions]="{ standalone: true }"
                   class="document-right-sidebarTagsInput"
                   [items]="selectedTags.length ? selectedTags : tags"
                   [disabled]="isDisabled"
                   [addTag]="true"
                   [isOpen]="false"
                   [multiple]="true"
                   bindLabel="value"
                   [placeholder]="t('Add Tag text for placeholder (Documents Section) - Add Tag')"
                   (add)="onAddTag($event)"
                   (remove)="onRemoveTag($event)">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-icon right" 
                  (click)="onRemoveTag(item)"
                  aria-hidden="true">×</span>
            <span class="ng-value-label">{{ item.value }}</span>
          </ng-template>
        </ng-select>
      </div>
    </ng-container>
